import React from "react";
import { classes, Hr } from "../styles/verticalDivider";

const VerticalDivider = () => {
  return <Hr className={classes.root} />;
};

export default VerticalDivider;
